/* eslint consumerweb/require-pagename:0 */

import PropTypes from 'prop-types'
import React from 'react'
import Media from 'react-media'

import glamorous from 'glamorous'
import glamorousIcon from 'lib/glamorous-icon'

import { mediaQueries } from 'transfer/styles'
import { SIZE_MOBILE } from 'lib/styles/media-queries'
import { trackClickUnifiedSend } from 'transfer/utils/unified-send-analytics'
import content from 'pp-react-l10n'

import GSSvg from '../icons/svg/goodsandservices.svg'
import ShieldSvg from '../icons/svg/protectionShield.svg'
import CircledCheckMarkIcon from '../icons/react-check-mark-icon'
const i18nPaymentType = content('transfer/inc/paymentTypeChoices')
const { phoneLandscapeMax: mobile } = mediaQueries
import { isDw2Repaint } from 'experiments/dw2Repaint'
import {
  Spot,
  BodyText,
  CaptionText,
  v2black,
  v2grey300,
  v2blue500,
  Link,
} from '@paypalcorp/pp-react'

/**
 * Shield Icon
 */
class ShieldIcon extends React.Component {
  render() {
    const IconContainer = glamorous.div({
      position: 'absolute',
      top: 14,
      right: 16,
      display: 'flex',
      justifyContent: 'flex-end',
    })

    const IconSVG = glamorousIcon({
      flex: '1 1 auto',
      width: 20,
      zIndex: 1,
      [mobile]: {
        maxWidth: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      '& svg': { height: '20', width: '20' },
    })

    IconSVG.defaultProps = { svg: ShieldSvg }

    return (
      <IconContainer>
        {isDw2Repaint() ? (
          <Spot name="insured" aria-hidden={true} />
        ) : (
          <IconSVG />
        )}
      </IconContainer>
    )
  }
}

const IconContainer = glamorous.div({
  margin: isDw2Repaint() ? '0 0 4% 0' : 'auto auto 2% auto',
  display: 'flex',
  justifyContent: 'center',
  // [mobile]: {
  //   marginTop: 30,
  // },
})

const BasketIconSVG = glamorousIcon({
  flex: '1 1 auto',
  height: 52,
  width: 40,
  [mobile]: {
    maxWidth: 40,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  '& svg': { height: '52', width: '40' },
})

BasketIconSVG.defaultProps = { svg: GSSvg }

const ButtonLink = glamorous.button({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: 'white',
  margin: '0 auto',
  border: '0px',
  position: 'relative',
  textDecoration: 'none',
  padding: isDw2Repaint() ? '1%' : '0%',
  maxWidth: isDw2Repaint() ? '95%' : '360px',
  cursor: 'pointer',
  color: isDw2Repaint() ? v2black : '#0070BA',
  ...(isDw2Repaint() && { width: '100%', alignItems: 'center' }),
  // [mobile]: {
  //   minHeight: '240px',
  // },
})

const SelectContainer = glamorous.div(
  {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    border: isDw2Repaint() ? '3px solid' : '1px solid',
    ...(isDw2Repaint() && { boxSizing: 'border-box' }),
    borderRadius: isDw2Repaint() ? '6px' : '10px',
    backgroundColor: 'white',
    margin: isDw2Repaint() ? '1% auto' : '0 auto',
    position: 'relative',
    textDecoration: 'none',
    maxWidth: isDw2Repaint() ? '28rem' : '360px',
    cursor: 'pointer',
    padding: isDw2Repaint() ? '6%' : '4%',
    color: isDw2Repaint() ? v2black : '#0070BA',
    width: '100%',
    transition: 'border-color ease .2s',
    textAlign: 'center',
    [mobile]: {
      ...(isDw2Repaint() && { maxWidth: '95%' }),
    },
    // [mobile]: {
    //   minHeight: '240px',
    // },
  },
  ({ selected }) => ({
    ...(isDw2Repaint() && { border: selected ? '3px solid' : '1px solid' }),
    ...(isDw2Repaint() && {
      boxShadow: selected ? '0 0 0 0.375rem rgb(16 114 235 / 16%)' : 'none',
    }),
    // eslint-disable-next-line no-nested-ternary
    borderColor: isDw2Repaint()
      ? selected
        ? v2blue500
        : v2grey300
      : selected
      ? '#00CF92'
      : '#E1E7EB',
    ':hover': {
      // eslint-disable-next-line no-nested-ternary
      borderColor: isDw2Repaint()
        ? v2blue500
        : selected
        ? '#00CF92'
        : '#009CDE',
    },
  })
)

const PDescription = glamorous.p({
  position: 'relative',
  left: 0,
  bottom: 0,
  color: '#000000',
  margin: '4% 5% 0 5%',
  // [mobile]: {
  //   marginTop: '8%',
  //   bottom: '6px',
  // },
})

class PurchaseProtectionLink extends React.Component {
  handlePurchaseProtectionClick = event => {
    event.stopPropagation()
    trackClickUnifiedSend('purchaseProtection')
  }

  render() {
    return isDw2Repaint() ? (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <Link
            {...(matches && { size: 'sm' })}
            onClick={this.handlePurchaseProtectionClick}
            href={i18nPaymentType('goods.purchaseProtectionLink')}
            target="_blank"
          >
            {i18nPaymentType('goods.purchaseProtection')}
          </Link>
        )}
      </Media>
    ) : (
      <a
        onClick={this.handlePurchaseProtectionClick}
        href={i18nPaymentType('goods.purchaseProtectionLink')}
        target="_blank"
      >
        {i18nPaymentType('goods.purchaseProtection')}
      </a>
    )
  }
}

class GoodsAndServicesCard extends React.Component {
  static propTypes = {
    selected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    selected: false,
  }

  render() {
    const { selected } = this.props

    // We must move the text outside the button, due to HTML5 not allowing links inside buttons.
    return isDw2Repaint() ? (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <SelectContainer
            onClick={this.props.handleClick}
            selected={selected}
            data-testid="gscard"
          >
            <ButtonLink
              tabindex="0"
              className="txtCenter"
              name="goodsPayment"
              data-nemo="gscard"
            >
              <IconContainer>
                <Spot name="insured" size="lg" aria-hidden={true} />
              </IconContainer>
              <BodyText strong align="center">
                {i18nPaymentType('goods.title')}
              </BodyText>
              {matches ? (
                <CaptionText align="center">
                  {i18nPaymentType('goods.description', {
                    purchaseProtectionLink: <PurchaseProtectionLink />,
                  })}
                </CaptionText>
              ) : (
                <BodyText align="center">
                  {i18nPaymentType('goods.description', {
                    purchaseProtectionLink: <PurchaseProtectionLink />,
                  })}
                </BodyText>
              )}
            </ButtonLink>
          </SelectContainer>
        )}
      </Media>
    ) : (
      <SelectContainer
        className="txtCenter"
        data-testid="gscard"
        onClick={this.props.handleClick}
        selected={selected}
      >
        <ShieldIcon />
        {selected && <CircledCheckMarkIcon />}
        <ButtonLink
          tabindex="0"
          className="txtCenter"
          name="goodsPayment"
          data-nemo="gscard"
        >
          <IconContainer>
            <BasketIconSVG />
          </IconContainer>
          <glamorous.Div margin="auto" className="vx_text-3">
            {i18nPaymentType('goods.title')}
          </glamorous.Div>
        </ButtonLink>
        <PDescription className="vx_text-6_lighter">
          {i18nPaymentType('goods.description', {
            purchaseProtectionLink: <PurchaseProtectionLink />,
          })}
        </PDescription>
      </SelectContainer>
    )
  }
}

export default GoodsAndServicesCard
